export default {
  SET_BRIGADE(state, data) {
    state.brigade = data
  },
  SET_ONE_BRIGADE(state, data) {
    state.one_brigade = data
  },
  SET_BRIGADE_WORK_TYPE_LOADING(state, data) {
    state.workTypeLoading = data
  },
}
